import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

/* eslint-disable no-new */
function isValidUrl(string) {
  try {
    new URL(string)
  } catch (_) {
    return false
  }

  return true
}
/* eslint-enable no-new */

const CustomCanonical = ({ canonical }) => {
  if (!isValidUrl(canonical)) {
    return null
  }

  const url = new URL(canonical)

  return (
    <Helmet>
      <link
        rel="canonical"
        href={canonical}
        data-baseprotocol={url.protocol}
        data-basehost={url.hostname}
      />
    </Helmet>
  )
}

CustomCanonical.propTypes = {
  canonical: PropTypes.string.isRequired,
}

export default CustomCanonical
